/**
 * CardVariantSync
 *
 * Custom element that wraps the variant picker + buy button inside a product
 * card (card-product.liquid). It listens for option changes, finds the
 * matching variant from the embedded JSON, and keeps the hidden
 * `input[name="id"]` (and the submit button state) in sync — replacing the
 * role that `product-info` plays on the full product page.
 */
if (!customElements.get("card-variant-sync")) {
  customElements.define(
    "card-variant-sync",
    class CardVariantSync extends HTMLElement {
      connectedCallback() {
        const variantsData = this.querySelector("[data-card-variants]");
        if (!variantsData) return;

        try {
          this.variants = JSON.parse(variantsData.textContent);
        } catch (e) {
          console.error("[card-variant-sync] Failed to parse variants JSON", e);
          return;
        }

        this.addEventListener("change", this.onVariantChange.bind(this));
      }

      onVariantChange() {
        const selectedOptions = this.getSelectedOptions();
        if (!selectedOptions.length) return;

        const variant = this.variants.find((v) =>
          [v.option1, v.option2, v.option3]
            .filter(Boolean)
            .every((opt, i) => opt === selectedOptions[i]),
        );

        const variantInput = this.querySelector(
          'input[name="id"].product-variant-id',
        );
        if (!variantInput) return;

        if (variant) {
          variantInput.value = variant.id;
          variantInput.disabled = !variant.available;
          variantInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        const submitButton = this.querySelector('product-form [type="submit"]');
        if (!submitButton) return;

        if (variant && variant.available) {
          submitButton.removeAttribute("disabled");
        } else {
          submitButton.setAttribute("disabled", "disabled");
        }
      }

      getSelectedOptions() {
        return Array.from(this.querySelectorAll("fieldset"))
          .map((fieldset) => {
            const checked = fieldset.querySelector(
              'input[type="radio"]:checked',
            );
            return checked ? checked.value : null;
          })
          .filter(Boolean);
      }
    },
  );
}
